import { Dialog, DialogContent } from "@mui/material";

import constants from "../../../../../utils/constants";
import DialogHeader from "../../../../UI/DialogHeader";

export default function InfoDialog(props) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader title="Why do we ask for this info?" onClose={onClose} />
      <DialogContent>
        <p>We want you to have a great experience!</p>
        <p>
          To get you started, we always ask a few basic questions in order to help us prepare for your meeting and
          better answer your questions.
        </p>
        <p>We will never share this information with another company or person outside of Litco Law.</p>
        <p>
          Have questions? Call{" "}
          <strong>
            <a href={"tel:+" + constants.LITCO_NUMBER}>{constants.LITCO_NUMBER}</a>
          </strong>{" "}
          to speak with a member of our team.
        </p>
      </DialogContent>
    </Dialog>
  );
}
